"use strict";

var _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e
} : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
};


var embedInst = embedInst || {};


// embedInst.baseurl = "https://getdrivebuy.com";
embedInst.baseurl = "https://wtb.bio";
embedInst.divSelector = ".drb_zwdg";

embedInst.embeds = [];

embedInst.init = function () {
    this.oneTimeInit();
    this.polyfills();
    var e = document.querySelector(this.divSelector);
    e && e.getAttribute("data-baseurl") && (this.baseurl = e.getAttribute("data-baseurl")), this.embed()
};

embedInst.oneTimeInit = function () {
    if (!this.initialized) {
        if (this.initialized = !0, document.getElementsByTagName("meta").viewport) document.getElementsByTagName("meta").viewport.content = "width=device-width, initial-scale=1, maximum-scale=1";
        else {
            var e = document.createElement("meta");
            e.setAttribute("name", "viewport"), e.setAttribute("content", "width=device-width, initial-scale=1"), document.querySelector("head").appendChild(e)
        }

        window.postMessage && window.addEventListener("message", function (e) {

            if ("object" === _typeof(e.data) && "drbw_fr_hd" === e.data.source) {
                var iframeId = e.data.sourceId,
                    iframe = document.querySelector("iframe#" + iframeId);
                // if (iframeId != 'dummy' && (void 0 === iframeId || null === iframe)) return void this.sendFrameIds();
                switch (e.data.type) {
                    case "scrollToTop":


                        // (null === iframe.parentNode.getAttribute("data-autoscroll") || "true" === iframe.parentNode.getAttribute("data-autoscroll")) && !this.isElementInViewport(iframe) && iframe.scrollIntoView({
                        //     behavior: "smooth"
                        // });
                        (null === iframe.parentNode.getAttribute("data-autoscroll") || "true" === iframe.parentNode.getAttribute("data-autoscroll"))  && iframe.scrollIntoView({
                            behavior: "smooth",block: 'start'
                        });
                        break;
                    case "outerHeight":
                        this.setHeight(iframe, e.data.payload);
                        break;
                    case "findStores":
                        this.findStores(iframeId, e.data.payload);
                        break;
                    case "widgetClose":
                        this.hidePopup(iframeId);
                        break;
                    default:
                        console.log("MSG", e)
                }
            }
            if ("object" === _typeof(e.data) && "drbw_fr_ct" === e.data.source) {

                var iframeId = e.data.sourceId,
                    iframe = document.querySelector("iframe#" + iframeId);
                // if (iframeId != 'dummy' && (void 0 === iframeId || null === iframe)) return void this.sendFrameIds();
                switch (e.data.type) {
                    case "scrollToTop":
                        // (null === iframe.parentNode.getAttribute("data-autoscroll") || "true" === iframe.parentNode.getAttribute("data-autoscroll")) && !this.isElementInViewport(iframe) && iframe.scrollIntoView({
                        //     behavior: "smooth"
                        // });
                        (null === iframe.parentNode.getAttribute("data-autoscroll") || "true" === iframe.parentNode.getAttribute("data-autoscroll"))  && iframe.scrollIntoView({
                            behavior: "smooth",block: 'start'
                        });
                        break;
                    case "outerHeight":
                        if (e.data.payload.bRadius != undefined) {
                            var div = document.querySelector("div#" + iframeId.substring(0, iframeId.length - 2) + '_d');

                                iframe.style.borderRadius = e.data.payload.bRadius + 'px'
                                div.style.borderRadius = e.data.payload.bRadius + 'px'
                        }
                        this.setHeight(iframe, e.data.payload.height);
                        break;
                    case "findStores":
                        this.findStores(iframeId, e.data.payload);
                        break;
                    case "widgetClose":
                        this.hidePopup(iframeId);
                        break;
                    default:
                        console.log("MSG", e)
                }
            }
            if ("object" === _typeof(e.data) && "mp_fr_pp" === e.data.source) {
                var iframeId = e.data.sourceId,
                    iframe = document.querySelector("iframe#" + iframeId);
                if ( (void 0 === iframeId || null === iframe)) return void this.sendFrameIds();
                switch (e.data.type) {
                    case "searchProducts":
                        var p = document.querySelector("iframe#" + iframeId);
                        p.contentWindow.postMessage({
                            source: "drbw_fr_parent",
                            type: "searchProducts",
                            payload: e.data.payload
                        }, "*")

                    default:
                        console.log("PP MSG", e)
                }
            }
        }.bind(this), !1)
    }
}

embedInst.embed = function () {
    document.querySelectorAll(this.divSelector).forEach(function (divCont) {

        if (null === divCont.querySelector("iframe")) {

            var mid =divCont.getAttribute("data-embed")
            var t = mid + '_' + divCont.getAttribute("data-product");

            if (-1 === this.embeds.indexOf(t)) {
                console.log(divCont)
                this.embeds.push(t);

                var dataset = divCont.dataset
                var width = divCont.getAttribute("data-width");
                divCont.style["max-width"] = width ? width + "px" : "100%";

                var n = divCont.getAttribute("data-height"),
                    mh = divCont.getAttribute("data-min-height"),
                    noResize = divCont.getAttribute("data-noresize");

                noResize && (divCont.style.height = "100%", divCont.style["-webkit-overflow-scrolling"] = "touch", n || (divCont.style.height = "100%"));

                var o = divCont.getAttribute("data-params"),
                    a = "";
                null !== o && o.split(",").forEach(function (e) {
                    a += "&" + e
                });
                var d = ["utm_source", "utm_medium", "utm_term", "utm_content", "utm_campaign", "gclid", "fbclid", "_ga", "_gl", "_gid", "_fbp", "blind", "wbprod"],
                    s = this.getAllUrlParams();

                for (var u in s) s.hasOwnProperty(u) && d.includes(u) && (a += "&" + u + "=" + s[u]);
                if (mh) {
                    a +='&minH=' + mh
                }

                var iframe = document.createElement("iframe");

                iframe.setAttribute("frameborder", "0");
                iframe.setAttribute("scrolling", "no");
                iframe.setAttribute("allow", "geolocation");
                iframe.style.width = "100%";
                iframe.style.overflow = "hidden";
                iframe.style.display = 'block';

                iframe.id = "_" + Math.random().toString(36).substr(2, 9);

                noResize && (iframe.style.height = "100%");

                n && (iframe.style["min-height"] = n + "px");

                iframe.src = this.baseurl + "whead/" + mid + "?embed=1" + (noResize ? "&noresize=1" : "") + "&src=" + encodeURIComponent(document.location.href) + a;
                divCont.appendChild(iframe);

                var m = divCont.querySelector("iframe#" + iframe.id);
                m.onload = function () {
                    embedInst.sendFrameId(m, 'setId', dataset)
                };
                iframe.style.height = "44px"
               // noResize || this.makeResponsive(divCont.querySelector("iframe#" + iframe.id))


                var divHolder = document.createElement("div");
                divHolder.style.position = 'relative'

                var divDropdown = document.createElement("div");

                if (mid == 'epicureanbutter') {
                    divDropdown.style.width = "100%";
                } else {
                    divDropdown.style.width = "350px";
                }

                //divDropdown.style.maxHeight = "400px";
                divDropdown.style.position = "absolute";
                divDropdown.style.zIndex = 1;
                divDropdown.style.top = 0;
                divDropdown.style.left = 0;

                divDropdown.style.display = 'none';
                //divDropdown.style.overflowY = 'scroll';
                divDropdown.style.boxShadow = "1px 1px 3px 0px #bbbaba";
                divDropdown.style.backgroundColor = "white";
                divDropdown.id = iframe.id + '_d';

                var iframe2 = document.createElement("iframe");

                iframe2.setAttribute("frameborder", "0");
                 iframe2.style.width = "100%";
                iframe2.style.height = "1px";
                // iframe2.style.overflow = "hidden";
                // iframe2.style.position = "fixed";
                // iframe2.style.top = "0";
                // iframe2.style.left = "0";
                //  iframe2.style.height = "3000px";
                // iframe2.style.zIndex = "99999999";
                // iframe2.style.display = 'none'

                iframe2.id = iframe.id + '_a';

                iframe2.src = this.baseurl + "wcont/" + mid + (mid != '' ? '/' : '') +'' + "?embed=1" + (noResize ? "&noresize=1" : "") + "&src=" + encodeURIComponent(document.location.href) + a;

                divDropdown.appendChild(iframe2)
                divHolder.appendChild(divDropdown)
                divCont.appendChild(divHolder);

                var m2 = divCont.querySelector("iframe#" + iframe2.id);
                m2.onload = function () {
                    embedInst.sendFrameId(m2, 'setAId', dataset)
                };
            }
        }
    }.bind(this))
}

embedInst.activeIframe = null
embedInst.findStores = function(iframeId, payload) {

    var p = document.querySelector("iframe#" + iframeId + '_a');
    p.contentWindow.postMessage({
        source: "drbw_fr_parent",
        type: "findStores",
        payload: payload
    }, "*")
    var d = document.querySelector("div#" + iframeId + '_d');
    d.style.display = 'block'
    // embedInst.activeIframe =  p;
    // embedInst.activeIframe.style.display = 'block'
    // document.body.style.overflow = 'hidden'
}
embedInst.hidePopup = function(iframeId) {
    var d = document.querySelector("div#" + iframeId + '_d');
    d.style.display = 'none'
    // embedInst.activeIframe.style.display = 'none'
    // document.body.style.overflow = 'initial'
}
embedInst.sendFrameIds = function () {
    document.querySelectorAll(this.divSelector).forEach(function (e) {
        var t = e.querySelector("iframe");
        t && t.id && this.sendFrameId(t, 'setId')
    }.bind(this))
}

embedInst.sendFrameId = function (e, type, dataset) {

    if (dataset.notifyid == '1') {
        var ev = new Event('drbEmbedId')
        ev.prop = {id: e.id, dataset: dataset}
        window.dispatchEvent(ev)
        dataset.notifyid = false
    }

    e.contentWindow.postMessage({
        source: "drbw_fr_parent",
        type: type ? type : 'setId',
        h: 400,
       // h: window.innerHeight,
        payload: {id: e.id, dataset: JSON.stringify(dataset)}
    }, "*")


}

embedInst.ready = function (e) {
    (document.attachEvent ? "complete" === document.readyState : "loading" !== document.readyState) ? e() : document.addEventListener("DOMContentLoaded", e)
}

embedInst.polyfills = function () {
    window.NodeList && !NodeList.prototype.forEach && (NodeList.prototype.forEach = Array.prototype.forEach), Array.prototype.includes || Object.defineProperty(Array.prototype, "includes", {
        value: function (e, t) {
            if (null == this) throw new TypeError('"this" is null or not defined');
            var i = Object(this),
                n = i.length >>> 0;
            if (0 === n) return !1;
            for (var r = 0 | t, o = Math.max(r >= 0 ? r : n - Math.abs(r), 0); o < n;) {
                if (function (e, t) {
                    return e === t || "number" == typeof e && "number" == typeof t && isNaN(e) && isNaN(t)
                }(i[o], e)) return !0;
                o++
            }
            return !1
        }
    })
}

embedInst.bringIntoView = function (e) {
    ({
        started: 0,
        ends: 0,
        y: 0,
        tick: function () {
            var e, t, i, n, r;
            n = Date.now(), n < this.ends ? (t = n - this.started, i = this.ends - this.started, e = this.y - document.body.scrollTop, r = e * (t / i), document.body.scrollTop += r, window.requestAnimationFrame(this.tick.bind(this))) : document.body.scrollTop = this.y
        },
        bringIntoView: function (e, t) {
            this.started = Date.now(), this.ends = this.started + t, this.y = Math.min(document.body.scrollTop + e.getBoundingClientRect().top, document.body.scrollHeight - window.innerHeight), window.requestAnimationFrame(this.tick.bind(this))
        }
    }).bringIntoView(e, 600)
}

embedInst.targetHeight = {}

embedInst.setHeight = function (e, t) {
    var i = e.parentNode,
        n = null; //i.getAttribute("data-min-height");
    n && t < n && (t = n), t !== this.targetHeight[e.id] && (this.targetHeight[e.id] = t, e.style.height = t + "px", e.contentWindow.postMessage({
        source: "drbw_fr_parent",
        type: "setBodyClass",
        payload: "minheight"
    }, "*"))
}

embedInst.makeResponsive = function (e) {
    e.style.height = "300px"
    // e.style["transition-duration"] = "600ms"
    // e.style["-webkit-transition-duration"] = "600ms"
    this.targetHeight[e.id] = 0
}

embedInst.getAllUrlParams = function (e) {
    var t = e ? e.split("?")[1] : window.location.search.slice(1),
        i = {};
    if (t) {
        t = t.split("#")[0];
        for (var n = t.split("&"), r = 0; r < n.length; r++) {
            var o = n[r].split("="),
                a = o[0],
                d = void 0 === o[1] || o[1];
            if (a = a.toLowerCase(), "string" == typeof d && (d = d.toLowerCase()), a.match(/\[(\d+)?\]$/)) {
                var s = a.replace(/\[(\d+)?\]/, "");
                if (i[s] || (i[s] = []), a.match(/\[\d+\]$/)) {
                    var u = /\[(\d+)\]/.exec(a)[1];
                    i[s][u] = d
                } else i[s].push(d)
            } else i[a] ? i[a] && "string" == typeof i[a] ? (i[a] = [i[a]], i[a].push(d)) : i[a].push(d) : i[a] = d
        }
    }
    return i
}

embedInst.isElementInViewport = function (e) {
    var t = e.getBoundingClientRect();
    return t.top >= 0 && t.top <= (window.innerHeight || document.documentElement.clientHeight)
}

embedInst.ready(function () {
    embedInst.init()
});